const assets = {};

const res = require.context('.', true, /\.(png|jpe?g|gif|svg|mp4|webm|ogg|mp3|wav|flac|aac|woff2?|eot|ttf|otf)$/);
res.keys().forEach((key) => {
  assets[key.substr(2)] = res(key);
});

export default assets;



// WEBPACK FOOTER //
// ./src/assets/index.js